import { render } from "./CreateEOHModal.vue?vue&type=template&id=124edf5c&ts=true"
import script from "./CreateEOHModal.vue?vue&type=script&lang=ts"
export * from "./CreateEOHModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__